import { pList, rIstatistikSonuc_3, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IInputAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError, IKeyValPair } from '../../../../models/StateModels';

export const action_api_set_input = (body: pList | null | undefined): IInputAction<pList> =>
  ActionFunctions.action_api_set_input(ActionSubTypes.API_DEGERLEMETOPLAMDEGER, true, body);

export const action_async_start_promise = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_DEGERLEMETOPLAMDEGER,
    new Api.Stat.Degerleme.Toplam().Request(body),
    false,
    true,
    body
  );

export const action_async_complete_api = (
  data: rValue<rIstatistikSonuc_3> | null | undefined,
  error: IError | null | undefined
): IApiAction<rIstatistikSonuc_3> =>
  ActionFunctions.action_async_complete_api<rIstatistikSonuc_3>(
    ActionSubTypes.API_DEGERLEMETOPLAMDEGER,
    new rIstatistikSonuc_3({
      SonucListesi: ((data?.Value?.SonucListesi as unknown) as IKeyValPair[]) || [],
      AnahtarTuru: '',
      DegerTuru: '',
      Yillar: data?.Value?.Yillar || [],
    }),
    error
  );
